export default function Logo({ className = "", mark = 36 }) {
    return (
        <span className={`inline-flex items-center gap-2.5 ${className}`}>
            <svg width={mark} height={mark} viewBox="0 0 64 64" aria-hidden="true">
                <rect width="64" height="64" rx="16" fill="#FF9F1C" />
                <path
                    fill="#0B0C10"
                    fillRule="evenodd"
                    d="M20 14h10a18 18 0 0 1 0 36H20V14zm10 9.6v16.8l13.5-8.4L30 23.6z"
                />
            </svg>
            <span className="font-display text-xl font-extrabold tracking-tight text-slate-50">
                deo<span className="text-amberx">editz</span>
            </span>
        </span>
    );
}
